import { render, staticRenderFns } from "./WimexUnderRootFertilization.vue?vue&type=template&id=0d21e817&scoped=true&lang=html&"
import script from "./WimexUnderRootFertilization.vue?vue&type=script&lang=js&"
export * from "./WimexUnderRootFertilization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21e817",
  null
  
)

export default component.exports